"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/layer/Property
 */

/**
 * @enum {string}
 */
var _default = {
  OPACITY: 'opacity',
  VISIBLE: 'visible',
  EXTENT: 'extent',
  Z_INDEX: 'zIndex',
  MAX_RESOLUTION: 'maxResolution',
  MIN_RESOLUTION: 'minResolution',
  MAX_ZOOM: 'maxZoom',
  MIN_ZOOM: 'minZoom',
  SOURCE: 'source',
  MAP: 'map'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLE9BQU8sRUFBRSxTQURJO0VBRWJDLE9BQU8sRUFBRSxTQUZJO0VBR2JDLE1BQU0sRUFBRSxRQUhLO0VBSWJDLE9BQU8sRUFBRSxRQUpJO0VBS2JDLGNBQWMsRUFBRSxlQUxIO0VBTWJDLGNBQWMsRUFBRSxlQU5IO0VBT2JDLFFBQVEsRUFBRSxTQVBHO0VBUWJDLFFBQVEsRUFBRSxTQVJHO0VBU2JDLE1BQU0sRUFBRSxRQVRLO0VBVWJDLEdBQUcsRUFBRTtBQVZRLEMiLCJuYW1lcyI6WyJPUEFDSVRZIiwiVklTSUJMRSIsIkVYVEVOVCIsIlpfSU5ERVgiLCJNQVhfUkVTT0xVVElPTiIsIk1JTl9SRVNPTFVUSU9OIiwiTUFYX1pPT00iLCJNSU5fWk9PTSIsIlNPVVJDRSIsIk1BUCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbGF5ZXIvUHJvcGVydHkuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=